<div class="post-container">    
    <div class="navigation-content">
        <h4 routerLink="/categories"><< powrót do kategorii</h4>
    </div>    
</div>

<div class="post-container">    
    <div class="post-title">
        <h2>Czujki, bolenie, pakucinki i stworzęta, <br />czyli o naszych bliskich i uczuciach</h2>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content">
        <p class="dfont center">
            Bliskość łączy się z wieloma silnymi uczuciami. Do bliskich nam osób – rodziny, przyjaciół, kolegów, sąsiadów, 
            a także do futrzanych pupili – zwracamy się w wyjątkowy sposób, używając pieszczotliwych określeń czy tworząc własne. 
            Wyrażamy w ten sposób szczególne uczucia i przywołujemy znane tylko nam zwyczaje, cechy i sytuacje. Bulgot, Marnusia, 
            Paprycja, Mamasia, Babek czy Przyjadzina to określenia z naszego słownika doMowego.
        </p>
    </div>
    <div class="post-content page-image">
        <img src="../../assets/game01/ufek.png" />
        <div class="inputs">
            <input class="input-czujki input-czujki-1" />
            <input class="input-czujki input-czujki-2" />
            <input class="input-czujki input-czujki-3" />
            <input class="input-czujki input-czujki-3" />
        </div>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content">
        <app-randomize [caption]="randomizeText"></app-randomize>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content page-boxes">
        <div class="box box-1">
            <div>
                <p class="dfont center">
                    Jak myślisz, jaką uczuciową barwę nadają poszczególne przyrostki?
                </p>
                <p class="dfont center">
                    Wybierz najciekawsze słowa i wyślij je do nas.
                </p>
            </div>
        </div>
        <div class="box box-2">
            <div>
                <input class="input-box" />
                <input class="input-box" />
                <input class="input-box" />
            </div>
        </div>
    </div>
</div>

<div class="post-container">
    <div class="post-content" style="text-align: right; margin-top: 50px;">
        <button class="dark"
            [routerLink]="['/task', taskId]">
            Przejdź dalej >>
        </button>
    </div>        
</div>

